import { Menu } from '@base-ui-components/react/menu'
import { cn } from '../../utils/cn'
import { LineIcon } from '../line-icon'

export function MenuRadioItem({ className, children, ...props }: MenuRadioItem.Props) {
  return (
    <Menu.RadioItem
      className={cn(
        'grid cursor-default select-none grid-cols-[0.75rem_1fr] items-center gap-2 py-2 pl-2.5 pr-8 text-sm leading-4 outline-none data-[highlighted]:relative data-[highlighted]:z-0 data-[highlighted]:before:absolute data-[highlighted]:before:inset-x-1 data-[highlighted]:before:inset-y-0 data-[highlighted]:before:z-[-1] data-[highlighted]:before:rounded-sm data-[highlighted]:before:bg-gray-100',
        className
      )}
      {...props}
    >
      <Menu.RadioItemIndicator className="col-start-1">
        <LineIcon.Check className="size-4" />
      </Menu.RadioItemIndicator>
      <div className="col-start-2">{children}</div>
    </Menu.RadioItem>
  )
}

export namespace MenuRadioItem {
  export interface Props extends Menu.RadioItem.Props {}
}
